<template>
  <div
    class="flex w-full items-center justify-between"
    style="position: relative;"
  >
    <div class="w-full flex justify-start items-center">
      <p @click="onClickNameLink" class="link-string ellipsis">
        {{ params.value }}
      </p>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
export default {
  name: "CellRendererLink",
  mixins: [ColorMixin],
  methods: {
    onClickNameLink() {
      const routeData = this.$router.resolve({
        name: "enterprise-management-daily-labor-record",
        params: { id: this.params.data.enterprise_manning_vessel_id },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@import "@/assets/scss/aisea/_variables.scss";
.link-string {
  color: $aisea-blue;
  cursor: pointer;
}
</style>
